// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1-li9","content":"LoadingAlert_content__37jVT"};